import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class PrintButtonModel extends ButtonBase {
    label: string = 'Print';
    action: string = ACTION_STATUS.print;
    matIconName: string = 'print';
    colorClass: string = 'color-info-500';
}